/* eslint-disable camelcase */
import { TableCell } from '@material-ui/core'
import ChipWithTooltip from '../../../components/Display/Chips/ChipWithTooltip'
import { ApplicationAmounts } from '../../Applications/values/handleApplicationsData'

const ApplicationsCell = ({
  created,
  accepted,
  noAvailableTimes,
  showingReserved
}: ApplicationAmounts) => {
  return (
    <TableCell>
      <ChipWithTooltip
        tooltip='Uusia'
        label={`${created}`}
        bgColor='#FFC300'
        size='small'
        color='white'
      />
      <ChipWithTooltip
        tooltip='Hyväksytty'
        label={`${accepted}`}
        size='small'
        bgColor='#22C500'
        color='white'
      />
      <ChipWithTooltip
        tooltip='Ei sopivia aikoja'
        label={`${noAvailableTimes}`}
        size='small'
        bgColor='#FF6E38'
        color='white'
      />
      <ChipWithTooltip
        tooltip='Näyttö varattu'
        label={`${showingReserved}`}
        size='small'
        bgColor='#5C6DCE'
        color='white'
      />
      {/* {renderApplicationsAmount('orange', created)}/{renderApplicationsAmount('green', accepted)}/
      {renderApplicationsAmount('aqua', showingReserved)}/{renderApplicationsAmount('red', tenant)} */}
    </TableCell>
  )
}
export default ApplicationsCell
